import selectAll, { selectOne } from '../../helpers/jquery-replace';

const updateIndicator = (el: HTMLElement) => {
    const indicator = selectOne('.nav-main__link-indicator') as HTMLElement;
    if (indicator) {
        indicator.style.left = el.offsetLeft + 'px';
    }
};

const makeParentIndicator = (el: HTMLElement) => {
    const template = document.createElement('template');
    template.innerHTML = '<span class=\'nav-main__link-indicator u-hide-for-small\' style=\'left:' + el.offsetLeft + 'px; width:' + el.offsetWidth + 'px;\'></span>';
    const globalHeader = selectOne('.global-header') as HTMLElement;
    if (globalHeader) {
        globalHeader.appendChild(template.content);
    }
};

export default class Menu {
    private handleClickOutside: ((e: MouseEvent) => void) | null = null;
    private element: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;
        this.init();
    }

    private init() {
        this.setupHeaderHeight();
        this.setupDesktopHoverMenus();
        this.setupMobileMenu();
        this.setupMobileSubmenus();
        this.setupActiveLinkIndicator();
    }

    private setupMobileMenu() {
        selectAll('._js-mobile-menu-trigger').forEach((trigger: HTMLElement) => {
            trigger.addEventListener('click', () => {
                const isOpen = this.element.classList.contains('is-active');
                if (isOpen) {
                    this.closeMenu();
                } else {
                    this.openMenu();
                }
            });
        });
    }

    private openMenu() {
        this.element.classList.add('is-active');
        (selectOne('body') as HTMLElement).classList.add('u-overflow-hidden');
        this.attachClickOutsideListener();
    }

    private closeMenu() {
        this.element.classList.remove('is-active');
        (selectOne('body') as HTMLElement).classList.remove('u-overflow-hidden');
        this.detachClickOutsideListener();
    }

    private attachClickOutsideListener() {
        if (this.handleClickOutside) return;

        this.handleClickOutside = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const isClickInsideMenu = this.element.contains(target);
            const isClickOnMobileMenuTrigger = selectAll('._js-mobile-menu-trigger').some(trigger => trigger.contains(target));

            if (!isClickInsideMenu && !isClickOnMobileMenuTrigger) {
                this.closeMenu();
                e.stopImmediatePropagation();
                e.preventDefault();
            }
        };

        document.addEventListener('click', this.handleClickOutside, true);
    }

    private detachClickOutsideListener() {
        if (!this.handleClickOutside) return;

        document.removeEventListener('click', this.handleClickOutside, true);
        this.handleClickOutside = null;
    }

    private setupMobileSubmenus() {
        const mobileExpanders = selectAll('._js-nav-main-expander');

        mobileExpanders.forEach((expander: HTMLElement) => {
            expander.addEventListener('click', (e) => {
                if (window.matchMedia('(max-width: 64.0625em)').matches) {
                    e.preventDefault();
                    (expander.closest('._js-nav-main-item') as HTMLElement)?.classList.toggle('is-expanded');
                }
            });
        });
    }

    private setupDesktopHoverMenus() {
        const mainItems = selectAll('._js-nav-main-item');
        mainItems.forEach((el: HTMLElement) => {
            const menuTrigger = el.querySelector('._js-nav-main-expander') as HTMLElement;
            const menuToExpand = el;
            const menuToExpandContainer = el.querySelector('._js-mega-menu-container') as HTMLElement;

            menuTrigger?.addEventListener('mouseenter', (e: Event) => {
                if (window.matchMedia('(min-width: 64.0625em)').matches) {
                    e.preventDefault();
                    selectAll('._js-nav-main-item').forEach((e: HTMLElement) => e.classList.remove('is-expanded'));
                    menuToExpand.classList.add('is-expanded');
                }
            });

            menuToExpandContainer?.addEventListener('mouseleave', () => {
                if (window.matchMedia('(min-width: 64.0625em)').matches) {
                    menuToExpand.classList.remove('is-expanded');
                }
            });
        });
    }

    private setupHeaderHeight() {
        const header = document.getElementsByTagName('header')[0];
        const headerContentElement = document.getElementById('_js-global-header__content');
        const headerHeight = headerContentElement?.offsetHeight ?? 0;

        header.style.setProperty('--header-height-total', `${headerHeight}px`);

        if (headerContentElement) {
            const resizeObserver = new ResizeObserver(() => {
                header.style.setProperty('--header-height-total', `${headerContentElement.offsetHeight - (headerContentElement.classList.contains("collapsed") ? 28 : 0)}px`);
            });
            resizeObserver.observe(headerContentElement);
        }

        const onLoad = () => {
            (selectOne('body') as HTMLElement).style['--headerHeight'] = headerHeight;
        };

        if (document.readyState !== 'loading') {
            onLoad();
        } else {
            document.addEventListener('DOMContentLoaded', onLoad);
        }
    }

    private setupActiveLinkIndicator() {
        // Only run on mobile
        if (!window.matchMedia('(max-width: 64.0625em)').matches) {
            return;
        }
        const activeLink = selectOne('.nav-main__link.self') || selectOne('.nav-main__link.on-path');
        
        if (activeLink) {
            makeParentIndicator(activeLink as HTMLElement);

            // Expand parent gender section
            const navItem = activeLink.closest('._js-nav-main-item');
            if (navItem) {
                navItem.classList.add('is-expanded');
            }

            const activeMegaMenuItem = document.querySelector('.self.mega-menu__link') as HTMLElement;
            if (!activeMegaMenuItem) return;

             // Scroll into view after DOM has settled
            requestAnimationFrame(() => {
                activeMegaMenuItem.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            });
        }

        // Reposition indicator on resize
        window.onresize = () => {
            if (activeLink) updateIndicator(activeLink as HTMLElement);
        };
    }

}
